import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const Sidebar = ({
  sideMenu,
  sideMenuCallback,
  configInfo,
  markersList,
  appDir,
  activeMarker,
  updateCenterData,
}) => {
  const { t } = useTranslation();
  const [markers, setMarkers] = useState([]);
  const [fullMarkers, setFullMarkers] = useState([]);
  const [configData, setInfo] = useState({});
  const [actMarker, setActMarker] = useState(null);
  useEffect(() => {
    setMarkers(markersList);
    setFullMarkers(markersList);
  }, [markersList]);

  useEffect(() => {
    setInfo(configInfo);
  }, [configInfo]);

  const itemClick = (value) => {
    value.open = true;
    updateCenterData(value);
  };
  useEffect(() => {
    setActMarker(activeMarker);
  }, [activeMarker]);

  const filterCases = (e) => {
    if (e.target.value.length > 2) {
      var newArray = markersList.filter(function (el) {
        let searchBy =
          el.guardianName +
          el.occupientAr +
          el.occupientEn +
          el.fileTypeEn +
          el.fileTypeAr +
          el.makaniNumber +
          el.locationStatusEn +
          el.locationStatusAr +
          el.hazardLevelAr +
          e.hazardLevelEn +
          el.fileNumber;

        return searchBy.toLowerCase().includes(e.target.value.toLowerCase());
      });
      setMarkers(newArray);
    } else {
      setMarkers(fullMarkers);
    }
  };
  return (
    <div>
      <aside
        className={`fixed top-0 left-0 z-20 flex flex-col flex-shrink-0 w-96 h-full pt-16 font-normal duration-75  transition-width ${
          sideMenu ? " flex" : "hidden"
        }`}
      >
        <div className="relative flex flex-col flex-1 min-h-0 pt-0 bg-white border-r border-gray-200 dark:bg-gray-800 dark:border-gray-700">
          <div
            dir={appDir}
            className="flex flex-col flex-1 m-4  pb-4 overflow-y-auto"
          >
            <div className="border-b bottom-1 mb-4">
              <h3 className="text-black text-lg font-semibold leading-10">
                {t("Locations")}
              </h3>
            </div>
            <div className="flex flex-row mb-3 justify-start items-center bg-gray-50 rounded-3xl px-2 shadow border border-gray-200">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                className="mx-2"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="Outline / Search / Magnifer">
                  <path
                    id="Vector"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5 2.75C6.66751 2.75 2.75 6.66751 2.75 11.5C2.75 16.3325 6.66751 20.25 11.5 20.25C16.3325 20.25 20.25 16.3325 20.25 11.5C20.25 6.66751 16.3325 2.75 11.5 2.75ZM1.25 11.5C1.25 5.83908 5.83908 1.25 11.5 1.25C17.1609 1.25 21.75 5.83908 21.75 11.5C21.75 14.0605 20.8111 16.4017 19.2589 18.1982L22.5303 21.4697C22.8232 21.7626 22.8232 22.2374 22.5303 22.5303C22.2374 22.8232 21.7626 22.8232 21.4697 22.5303L18.1982 19.2589C16.4017 20.8111 14.0605 21.75 11.5 21.75C5.83908 21.75 1.25 17.1609 1.25 11.5Z"
                    fill="#1C274C"
                  />
                </g>
              </svg>

              <input
                type="text"
                onChange={filterCases}
                placeholder={t("Whatareyoulookingfor")}
                className="border-0 flex-grow bg-gray-50 py-3 rounded focus:ring-0"
              ></input>
            </div>
            {markers?.map((info, i) => {
              return (
                <div
                  key={i}
                  onClick={() => {
                    itemClick(info);
                  }}
                  className={`flex cursor-pointer flex-col bottom-1  rounded gap-4 my-2 ${
                    info.id === actMarker?.id
                      ? "border border-red-600"
                      : " border"
                  }`}
                >
                  <div className="flex flex-row items-center justify-start p-4  border-b">
                    <div className="flex flex-col flex-grow">
                      <div className="flex flex-col justify-between gap-4">
                        <h4 className="text-zinc-800 text-base font-semibold">
                          {info.locationTitle}
                        </h4>
                        {/* <h5 className="text-zinc-800 text-base font-normal">
                          {info.keySerial}
                        </h5> */}

                        <a
                          href={
                            "https://www.google.com/maps/dir/" +
                            info.gx +
                            "," +
                            info.gy
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            width="50"
                            height="50"
                            viewBox="0 0 64 64"
                          >
                            <path
                              fill="#fff7f0"
                              d="M57,28.33V51a6,6,0,0,1-6,6H13a6,6,0,0,1-6-6V13a6,6,0,0,1,6-6H39.23"
                            ></path>
                            <path
                              fill="#72caaf"
                              d="M7,51V13a6,6,0,0,1,6-6H39.23L39,19Z"
                            ></path>
                            <path
                              fill="#f9e3ae"
                              d="M13,57,9,56,7.17,52.17C7.17,48.85,42.5,16,42.5,16l.21,11.54Z"
                            ></path>
                            <path
                              fill="#97e0bb"
                              d="M57,7H12c-.55,0-4,2.45-4,3H8a4,4,0,0,0,4,4H58a4,4,0,0,0,4-4h0C62,9.45,57.55,7,57,7Z"
                            ></path>
                            <path
                              fill="#faefde"
                              d="M36.6,33.6,57,54c0-3.31.52-26.84.52-26.84l-14.79.41Z"
                            ></path>
                            <path
                              fill="#85cbf8"
                              d="M13 57L50 57 31.45 38.71 13 57z"
                            ></path>
                            <path
                              fill="#ed7899"
                              d="M37,14.28a13,13,0,0,1,26,0c0,9.39-11.56,17.33-13,28.84C48.56,31.62,37,23.67,37,14.28Z"
                            ></path>
                            <path
                              fill="#f9dd8f"
                              d="M50 9A5 5 0 1 0 50 19A5 5 0 1 0 50 9Z"
                            ></path>
                            <path
                              fill="#8d6c9f"
                              d="M17 16a1 1 0 0 0 1-1V13a1 1 0 0 0-2 0v2A1 1 0 0 0 17 16zM12 16a1 1 0 0 0 1-1V13a1 1 0 0 0-2 0v2A1 1 0 0 0 12 16zM32 16a1 1 0 0 0 1-1V13a1 1 0 0 0-2 0v2A1 1 0 0 0 32 16zM22 16a1 1 0 0 0 1-1V13a1 1 0 0 0-2 0v2A1 1 0 0 0 22 16zM27 16a1 1 0 0 0 1-1V13a1 1 0 0 0-2 0v2A1 1 0 0 0 27 16z"
                            ></path>
                            <path
                              fill="#8d6c9f"
                              d="M64,14.28A14,14,0,0,0,38.74,6H13a7,7,0,0,0-7,7V51c0,.12,0,.23,0,.35a1,1,0,0,0,0,.25A7,7,0,0,0,12.4,58a1,1,0,0,0,.16,0l.09,0L13,58H51a7,7,0,0,0,7-7V28.33s0,0,0,0C61.1,23.63,64,19.22,64,14.28Zm-14-12a12,12,0,0,1,12,12c0,4.4-2.82,8.62-5.8,13.09-2.38,3.56-4.81,7.21-6.2,11.34-1.38-4.13-3.82-7.78-6.2-11.34-3-4.47-5.8-8.69-5.8-13.09A12,12,0,0,1,50,2.28ZM13,8H37.51A13.89,13.89,0,0,0,36,14.28a15,15,0,0,0,1.18,5.6l-.1.06L8,49V13A5,5,0,0,1,13,8ZM8.08,51.78l30-30A52.77,52.77,0,0,0,41.15,27L12.22,55.92A5,5,0,0,1,8.08,51.78Zm23.14-12L47.47,56H15ZM51,56h-.7L32.64,38.33l3.64-3.64L40.54,39A1,1,0,0,0,42,37.54l-4.26-4.26,4.59-4.59c3,4.48,6,9.13,6.73,14.56a1,1,0,0,0,2,0c.55-4.38,2.65-8.25,5-11.94V51a4.9,4.9,0,0,1-.05.53l-4.37-4.37a1,1,0,0,0-1.41,1.41l5.07,5.07A5,5,0,0,1,51,56Z"
                            ></path>
                            <path
                              fill="#8d6c9f"
                              d="M50 12A2 2 0 1 0 50 16A2 2 0 1 0 50 12Z"
                            ></path>
                            <path
                              fill="#8d6c9f"
                              d="M50,20a6,6,0,0,0,6-6,1,1,0,0,0-2,0,4,4,0,1,1-5.2-3.82,1,1,0,1,0-.6-1.91A6,6,0,0,0,50,20Z"
                            ></path>
                            <path
                              fill="#8d6c9f"
                              d="M51.48 10.28a4 4 0 0 1 1.45 1 1 1 0 1 0 1.46-1.36 6 6 0 0 0-2.17-1.48 1 1 0 1 0-.74 1.86zM44.89 40.48a1 1 0 0 0-1.41 1.41l1.85 1.85a1 1 0 0 0 1.41-1.41z"
                            ></path>
                            <path
                              fill="#faefde"
                              d="M18,30a6,6,0,0,0,6-6,1,1,0,0,0-1-1H19.25a1,1,0,0,0,0,2h2.62a4,4,0,1,1-2-4.52,1,1,0,1,0,1-1.76A6,6,0,1,0,18,30Z"
                            ></path>
                          </svg>{" "}
                        </a>
                      </div>
                    </div>
                    <svg
                      width="35"
                      height="35"
                      className={`${appDir === "ltr" ? "" : "rotate-180"}`}
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="Outline / Arrows / Alt Arrow Right">
                        <path
                          id="Vector (Stroke)"
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.09327 3.69149C7.35535 3.46685 7.74991 3.4972 7.97455 3.75928L12.9745 9.59262C13.1752 9.82667 13.1752 10.172 12.9745 10.4061L7.97455 16.2394C7.74991 16.5015 7.35535 16.5319 7.09327 16.3072C6.83119 16.0826 6.80084 15.688 7.02548 15.426L11.6768 9.99936L7.02548 4.57277C6.80084 4.31069 6.83119 3.91613 7.09327 3.69149Z"
                          fill="#1C274C"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="flex flex-col gap-3  px-4 pb-4">
                    <div className="gap-2 flex justify-between flex-col">
                      <span className="text-red-700 text-sm font-medium">
                        بيانات القضية
                      </span>
                      <div className="text-sm font-bold">
                        {info.fileNumber} - {info.fileYear} - {info.fileTypeEn}
                      </div>
                    </div>
                    <div className="gap-2 flex justify-between flex-col">
                      <span className="text-red-700 text-sm font-medium">
                        الحارس القضائي
                      </span>
                      <div className="text-zinc-800 text-sm font-medium">
                        {info.guardianName}
                      </div>
                    </div>

                    <div className="gap-2 flex justify-between flex-col">
                      <span className="text-red-700 text-sm font-medium">
                        رقم مكاني
                      </span>
                      <div className="text-zinc-800 text-sm font-medium">
                        {info.makaniNumber}
                      </div>
                    </div>

                    {info.keySerial && (
                      <div className="gap-2 flex justify-between flex-col">
                        <span className="text-sm font-medium text-red-700">
                          رقم المفتاح
                        </span>
                        <div className="text-zinc-800 text-sm font-medium">
                          {info.keySerial}
                        </div>
                      </div>
                    )}
                    {/* <div className="text-zinc-800 text-sm font-medium">
                      {configData?.fileTypes?.map((fileType) => {
                        {
                          return (
                            fileType.id === info.fileTypeId && (
                              <span key={fileType.id}> {fileType.title} </span>
                            )
                          );
                        }
                      })}
                    </div> */}
                    <div className="flex flex-row gap-5">
                      <div
                        className={`flex flex-col flex-grow items-start  justify-start gap-1 ${
                          appDir === "ltr" ? "border-r" : "border-l"
                        }`}
                      >
                        <h4 className="text-neutral-400 text-sm font-normal">
                          {t("Status")}
                        </h4>
                        {configData?.locationStatuses?.map(
                          (locationStatuse) => {
                            return (
                              locationStatuse.id === info.locationStatusId && (
                                <div
                                  key={locationStatuse.id}
                                  className="flex flex-row gap-2 items-center"
                                >
                                  {locationStatuse.id === 1 && (
                                    <svg
                                      width="25"
                                      height="25"
                                      viewBox="0 0 28 28"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M23.0421 7.58343V20.4168C23.0415 21.1128 22.7648 21.7801 22.2726 22.2722C21.7805 22.7644 21.1131 23.0411 20.4171 23.0418H18.6671C18.4351 23.0418 18.2125 22.9496 18.0484 22.7855C17.8843 22.6214 17.7921 22.3988 17.7921 22.1668C17.7921 21.9347 17.8843 21.7121 18.0484 21.548C18.2125 21.3839 18.4351 21.2918 18.6671 21.2918H20.4171C20.6492 21.2918 20.8718 21.1996 21.0359 21.0355C21.2 20.8714 21.2921 20.6488 21.2921 20.4168V7.58343C21.2921 7.35136 21.2 7.1288 21.0359 6.96471C20.8718 6.80062 20.6492 6.70843 20.4171 6.70843H18.6671C18.4351 6.70843 18.2125 6.61624 18.0484 6.45215C17.8843 6.28805 17.7921 6.06549 17.7921 5.83343C17.7921 5.60136 17.8843 5.3788 18.0484 5.21471C18.2125 5.05062 18.4351 4.95843 18.6671 4.95843H20.4171C21.1131 4.95905 21.7805 5.23581 22.2726 5.72796C22.7648 6.2201 23.0415 6.88743 23.0421 7.58343ZM16.2265 3.2026C16.5336 3.44805 16.7815 3.75962 16.9516 4.11412C17.1216 4.46862 17.2096 4.85691 17.2088 5.2501V22.7501C17.2088 23.4463 16.9323 24.114 16.44 24.6062C15.9477 25.0985 15.28 25.3751 14.5838 25.3751C14.3908 25.3749 14.1983 25.3538 14.0098 25.3121L7.00981 23.7569C6.42485 23.6296 5.9014 23.3051 5.52716 22.8379C5.15292 22.3706 4.95062 21.7889 4.95415 21.1903V6.80643C4.95062 6.20778 5.15292 5.62609 5.52716 5.15882C5.9014 4.69155 6.42485 4.36708 7.00981 4.23976L14.0098 2.6846C14.3944 2.59824 14.7936 2.59998 15.1775 2.68968C15.5613 2.77939 15.92 2.95473 16.2265 3.2026ZM15.4588 5.2501C15.4582 5.01842 15.366 4.7964 15.2023 4.63247C15.0386 4.46854 14.8167 4.37602 14.585 4.3751C14.5206 4.37504 14.4563 4.38248 14.3936 4.39726L7.39365 5.95243C7.19899 5.99489 7.0248 6.10285 6.90016 6.25828C6.77552 6.41371 6.70798 6.6072 6.70881 6.80643V21.1938C6.70798 21.393 6.77552 21.5865 6.90016 21.7419C7.0248 21.8973 7.19899 22.0053 7.39365 22.0478L14.3936 23.6029C14.5215 23.6314 14.6541 23.6308 14.7816 23.6012C14.9092 23.5716 15.0285 23.5137 15.1307 23.4319C15.2329 23.35 15.3155 23.2463 15.3723 23.1283C15.429 23.0103 15.4586 22.881 15.4588 22.7501V5.2501ZM12.2738 12.8334H12.2621C11.9517 12.835 11.6545 12.9596 11.4358 13.1799C11.2171 13.4003 11.0947 13.6984 11.0955 14.0088C11.0963 14.3193 11.2201 14.6168 11.4399 14.836C11.6597 15.0553 11.9575 15.1784 12.268 15.1784C12.5784 15.1784 12.8762 15.0553 13.096 14.836C13.3158 14.6168 13.4397 14.3193 13.4405 14.0088C13.4412 13.6984 13.3189 13.4003 13.1002 13.1799C12.8814 12.9596 12.5843 12.835 12.2738 12.8334Z"
                                        fill="black"
                                      />
                                    </svg>
                                  )}
                                  {locationStatuse.id === 2 && (
                                    <svg
                                      width="25"
                                      height="25"
                                      viewBox="0 0 28 28"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M24.5 23.625H22.4583V5.25C22.4577 4.554 22.181 3.88668 21.6888 3.39453C21.1967 2.90238 20.5293 2.62562 19.8333 2.625H8.16667C7.47066 2.62562 6.80334 2.90238 6.31119 3.39453C5.81904 3.88668 5.54228 4.554 5.54167 5.25V23.625H3.5C3.26794 23.625 3.04538 23.7172 2.88128 23.8813C2.71719 24.0454 2.625 24.2679 2.625 24.5C2.625 24.7321 2.71719 24.9546 2.88128 25.1187C3.04538 25.2828 3.26794 25.375 3.5 25.375H24.5C24.7321 25.375 24.9546 25.2828 25.1187 25.1187C25.2828 24.9546 25.375 24.7321 25.375 24.5C25.375 24.2679 25.2828 24.0454 25.1187 23.8813C24.9546 23.7172 24.7321 23.625 24.5 23.625ZM7.29167 23.625V5.25C7.29167 5.01794 7.38385 4.79538 7.54795 4.63128C7.71204 4.46719 7.9346 4.375 8.16667 4.375H19.8333C20.0654 4.375 20.288 4.46719 20.4521 4.63128C20.6161 4.79538 20.7083 5.01794 20.7083 5.25V23.625H7.29167ZM18.69 14C18.69 14.2302 18.6218 14.4553 18.4942 14.6469C18.3665 14.8385 18.185 14.9881 17.9725 15.0767C17.7599 15.1653 17.526 15.1891 17.3 15.145C17.074 15.101 16.8661 14.991 16.7025 14.829C16.5389 14.667 16.4268 14.4602 16.3805 14.2347C16.3342 14.0091 16.3556 13.7749 16.4422 13.5616C16.5287 13.3482 16.6764 13.1652 16.8667 13.0356C17.057 12.906 17.2814 12.8356 17.5117 12.8333H17.5233C17.8328 12.8333 18.1295 12.9562 18.3483 13.175C18.5671 13.3938 18.69 13.6906 18.69 14Z"
                                        fill="black"
                                      />
                                    </svg>
                                  )}
                                  <div className="text-black text-sm font-medium ">
                                    {info.locationStatusAr}
                                  </div>
                                </div>
                              )
                            );
                          }
                        )}
                      </div>
                      <div
                        className={`flex flex-col flex-grow items-start  justify-start gap-1 ${
                          appDir === "ltr" ? "border-r" : "border-l"
                        }`}
                      >
                        <h4 className="text-neutral-400 text-sm font-normal">
                          {t("Occupants")}
                        </h4>
                        {configData?.occupiants?.map((occupiant) => {
                          return (
                            occupiant.id === info.occupiantId && (
                              <div
                                key={occupiant.id}
                                className="flex flex-row gap-2 items-center"
                              >
                                {occupiant.id === 1 && (
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clipPath="url(#clip0_463_2996)">
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M9 0.9375C4.5472 0.9375 0.9375 4.5472 0.9375 9C0.9375 13.4528 4.5472 17.0625 9 17.0625C13.4528 17.0625 17.0625 13.4528 17.0625 9C17.0625 4.5472 13.4528 0.9375 9 0.9375ZM2.0625 9C2.0625 5.16852 5.16852 2.0625 9 2.0625C10.7134 2.0625 12.2817 2.68363 13.492 3.71299C13.487 3.71764 13.4821 3.72239 13.4773 3.72725L3.72727 13.4771C3.72238 13.482 3.7176 13.4869 3.71292 13.492C2.6836 12.2816 2.0625 10.7133 2.0625 9ZM4.50787 14.2869C5.71824 15.3163 7.28658 15.9375 9 15.9375C12.8315 15.9375 15.9375 12.8315 15.9375 9C15.9375 7.28662 15.3164 5.71832 14.287 4.50797C14.2824 4.51296 14.2776 4.51789 14.2727 4.52276L4.52276 14.2726C4.51786 14.2775 4.5129 14.2823 4.50787 14.2869Z"
                                        fill="#040101"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_463_2996">
                                        <rect
                                          width="18"
                                          height="18"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                )}
                                {occupiant.id === 2 && (
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M11.6922 9.7575C9.26223 9.7575 7.28223 7.7775 7.28223 5.3475C7.28223 2.9175 9.26223 0.9375 11.6922 0.9375C14.1222 0.9375 16.1022 2.9175 16.1022 5.3475C16.1022 7.7775 14.1222 9.7575 11.6922 9.7575ZM11.6922 2.0625C9.88473 2.0625 8.40723 3.5325 8.40723 5.3475C8.40723 7.1625 9.87723 8.6325 11.6922 8.6325C13.5072 8.6325 14.9772 7.1625 14.9772 5.3475C14.9772 3.5325 13.4997 2.0625 11.6922 2.0625Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M4.76995 15.1434C3.18745 15.1434 1.89746 13.8534 1.89746 12.2709C1.89746 10.6884 3.18745 9.39844 4.76995 9.39844C6.35245 9.39844 7.64246 10.6884 7.64246 12.2709C7.64246 13.8534 6.35245 15.1434 4.76995 15.1434ZM4.76995 10.5234C3.80995 10.5234 3.02246 11.3034 3.02246 12.2709C3.02246 13.2309 3.80245 14.0184 4.76995 14.0184C5.72995 14.0184 6.51746 13.2384 6.51746 12.2709C6.51746 11.3109 5.72995 10.5234 4.76995 10.5234Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M12.4649 17.0627C11.0924 17.0627 9.98242 15.9452 9.98242 14.5802C9.98242 13.2077 11.0999 12.0977 12.4649 12.0977C13.8299 12.0977 14.9474 13.2152 14.9474 14.5802C14.9474 15.9452 13.8299 17.0627 12.4649 17.0627ZM12.4649 13.2151C11.7149 13.2151 11.1074 13.8226 11.1074 14.5726C11.1074 15.3226 11.7149 15.9302 12.4649 15.9302C13.2149 15.9302 13.8224 15.3226 13.8224 14.5726C13.8224 13.8301 13.2149 13.2151 12.4649 13.2151Z"
                                      fill="black"
                                    />
                                  </svg>
                                )}
                                {occupiant.id === 3 && (
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M9 11.0625C8.6925 11.0625 8.4375 10.8075 8.4375 10.5V6.75C8.4375 6.4425 8.6925 6.1875 9 6.1875C9.3075 6.1875 9.5625 6.4425 9.5625 6.75V10.5C9.5625 10.8075 9.3075 11.0625 9 11.0625Z"
                                      fill="#828282"
                                    />
                                    <path
                                      d="M9 13.4999C8.955 13.4999 8.9025 13.4924 8.85 13.4849C8.805 13.4774 8.76 13.4624 8.715 13.4399C8.67 13.4249 8.625 13.4024 8.58 13.3724C8.5425 13.3424 8.505 13.3124 8.4675 13.2824C8.3325 13.1399 8.25 12.9449 8.25 12.7499C8.25 12.5549 8.3325 12.3599 8.4675 12.2174C8.505 12.1874 8.5425 12.1574 8.58 12.1274C8.625 12.0974 8.67 12.0749 8.715 12.0599C8.76 12.0374 8.805 12.0224 8.85 12.0149C8.9475 11.9924 9.0525 11.9924 9.1425 12.0149C9.195 12.0224 9.24 12.0374 9.285 12.0599C9.33 12.0749 9.375 12.0974 9.42 12.1274C9.4575 12.1574 9.495 12.1874 9.5325 12.2174C9.6675 12.3599 9.75 12.5549 9.75 12.7499C9.75 12.9449 9.6675 13.1399 9.5325 13.2824C9.495 13.3124 9.4575 13.3424 9.42 13.3724C9.375 13.4024 9.33 13.4249 9.285 13.4399C9.24 13.4624 9.195 13.4774 9.1425 13.4849C9.0975 13.4924 9.045 13.4999 9 13.4999Z"
                                      fill="#828282"
                                    />
                                    <path
                                      d="M13.5449 16.6209H4.45486C2.99236 16.6209 1.87486 16.0884 1.30486 15.1284C0.74236 14.1684 0.81736 12.9309 1.52986 11.6484L6.07486 3.47336C6.82486 2.12336 7.85986 1.38086 8.99986 1.38086C10.1399 1.38086 11.1749 2.12336 11.9249 3.47336L16.4699 11.6559C17.1824 12.9384 17.2649 14.1684 16.6949 15.1359C16.1249 16.0884 15.0074 16.6209 13.5449 16.6209ZM8.99986 2.50586C8.29486 2.50586 7.60486 3.04586 7.05736 4.02086L2.51986 12.2034C2.00986 13.1184 1.92736 13.9584 2.27986 14.5659C2.63236 15.1734 3.41236 15.5034 4.46236 15.5034H13.5524C14.6024 15.5034 15.3749 15.1734 15.7349 14.5659C16.0949 13.9584 16.0049 13.1259 15.4949 12.2034L10.9424 4.02086C10.3949 3.04586 9.70486 2.50586 8.99986 2.50586Z"
                                      fill="#828282"
                                    />
                                  </svg>
                                )}
                                <div className="text-black text-sm font-medium ">
                                  {info.occupientAr}
                                </div>
                              </div>
                            )
                          );
                        })}
                      </div>
                      <div
                        className={`flex flex-col flex-grow items-start  justify-start gap-1 ${
                          appDir === "ltr" ? "border-r" : "border-l"
                        }`}
                      >
                        <h4 className="text-neutral-400 text-sm font-normal">
                          {t("LocationContent")}
                        </h4>
                        {configData?.locationContent?.map((locContent) => {
                          return (
                            locContent.id === info.locationContentId && (
                              <div
                                key={locContent.id}
                                className="flex flex-row gap-2 items-center"
                              >
                                {locContent.id === 1 && (
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clipPath="url(#clip0_463_2996)">
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M9 0.9375C4.5472 0.9375 0.9375 4.5472 0.9375 9C0.9375 13.4528 4.5472 17.0625 9 17.0625C13.4528 17.0625 17.0625 13.4528 17.0625 9C17.0625 4.5472 13.4528 0.9375 9 0.9375ZM2.0625 9C2.0625 5.16852 5.16852 2.0625 9 2.0625C10.7134 2.0625 12.2817 2.68363 13.492 3.71299C13.487 3.71764 13.4821 3.72239 13.4773 3.72725L3.72727 13.4771C3.72238 13.482 3.7176 13.4869 3.71292 13.492C2.6836 12.2816 2.0625 10.7133 2.0625 9ZM4.50787 14.2869C5.71824 15.3163 7.28658 15.9375 9 15.9375C12.8315 15.9375 15.9375 12.8315 15.9375 9C15.9375 7.28662 15.3164 5.71832 14.287 4.50797C14.2824 4.51296 14.2776 4.51789 14.2727 4.52276L4.52276 14.2726C4.51786 14.2775 4.5129 14.2823 4.50787 14.2869Z"
                                        fill="#040101"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_463_2996">
                                        <rect
                                          width="18"
                                          height="18"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                )}
                                {locContent.id === 2 && (
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M6.86992 8.715C6.84742 8.715 6.83242 8.715 6.80992 8.715C6.77242 8.7075 6.71992 8.7075 6.67492 8.715C4.49992 8.6475 2.85742 6.9375 2.85742 4.83C2.85742 2.685 4.60492 0.9375 6.74992 0.9375C8.89492 0.9375 10.6424 2.685 10.6424 4.83C10.6349 6.9375 8.98492 8.6475 6.89242 8.715C6.88492 8.715 6.87742 8.715 6.86992 8.715ZM6.74992 2.0625C5.22742 2.0625 3.98242 3.3075 3.98242 4.83C3.98242 6.33 5.15242 7.5375 6.64492 7.59C6.68992 7.5825 6.78742 7.5825 6.88492 7.59C8.35492 7.5225 9.50992 6.315 9.51742 4.83C9.51742 3.3075 8.27242 2.0625 6.74992 2.0625Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M12.4048 8.8125C12.3823 8.8125 12.3598 8.8125 12.3373 8.805C12.0298 8.835 11.7148 8.6175 11.6848 8.31C11.6548 8.0025 11.8423 7.725 12.1498 7.6875C12.2398 7.68 12.3373 7.68 12.4198 7.68C13.5148 7.62 14.3698 6.72 14.3698 5.6175C14.3698 4.4775 13.4473 3.555 12.3073 3.555C11.9998 3.5625 11.7448 3.3075 11.7448 3C11.7448 2.6925 11.9998 2.4375 12.3073 2.4375C14.0623 2.4375 15.4948 3.87 15.4948 5.625C15.4948 7.35 14.1448 8.745 12.4273 8.8125C12.4198 8.8125 12.4123 8.8125 12.4048 8.8125Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M6.87672 16.9125C5.40672 16.9125 3.92922 16.5375 2.81172 15.7875C1.76922 15.0975 1.19922 14.1525 1.19922 13.125C1.19922 12.0975 1.76922 11.145 2.81172 10.4475C5.06172 8.955 8.70672 8.955 10.9417 10.4475C11.9767 11.1375 12.5542 12.0825 12.5542 13.11C12.5542 14.1375 11.9842 15.09 10.9417 15.7875C9.81672 16.5375 8.34672 16.9125 6.87672 16.9125ZM3.43422 11.3925C2.71422 11.8725 2.32422 12.4875 2.32422 13.1325C2.32422 13.77 2.72172 14.385 3.43422 14.8575C5.30172 16.11 8.45172 16.11 10.3192 14.8575C11.0392 14.3775 11.4292 13.7625 11.4292 13.1175C11.4292 12.48 11.0317 11.865 10.3192 11.3925C8.45172 10.1475 5.30172 10.1475 3.43422 11.3925Z"
                                      fill="black"
                                    />
                                    <path
                                      d="M13.7546 15.5625C13.4921 15.5625 13.2596 15.3825 13.2071 15.1125C13.1471 14.805 13.3421 14.5125 13.6421 14.445C14.1146 14.3475 14.5496 14.16 14.8871 13.8975C15.3146 13.575 15.5471 13.17 15.5471 12.7425C15.5471 12.315 15.3146 11.91 14.8946 11.595C14.5646 11.34 14.1521 11.16 13.6646 11.0475C13.3646 10.98 13.1696 10.68 13.2371 10.3725C13.3046 10.0725 13.6046 9.87751 13.9121 9.94501C14.5571 10.0875 15.1196 10.3425 15.5771 10.695C16.2746 11.22 16.6721 11.9625 16.6721 12.7425C16.6721 13.5225 16.2671 14.265 15.5696 14.7975C15.1046 15.1575 14.5196 15.42 13.8746 15.5475C13.8296 15.5625 13.7921 15.5625 13.7546 15.5625Z"
                                      fill="black"
                                    />
                                  </svg>
                                )}

                                <div className="text-black text-sm font-medium ">
                                  {info.locationContentTitleAr}
                                </div>
                              </div>
                            )
                          );
                        })}
                      </div>
                    </div>
                    {info.HazardLevelAr && (
                      <div className="gap-2 flex justify-between flex-col mb-3 border-t bottom-1 py-2 my-2">
                        <span className="text-red-700 text-sm font-medium">
                          درجة الخطورة
                        </span>
                        <div className="text-sm font-bold">
                          {info.fileNumber} - {info.fileYear} -{" "}
                          {info.HazardLevelAr}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </aside>

      <div
        className="fixed inset-0 z-10 hidden bg-gray-900/50 dark:bg-gray-900/90"
        id="sidebarBackdrop"
      ></div>
    </div>
  );
};

export default Sidebar;
